import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  DatePicker,
  Input,
  Table,
  Select,
  Button,
  Tag,
  Radio,
  Spin,
  Popconfirm,
  message,
  Tooltip
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import Stats from "./parts/reviewscheduler/stats";
import AgencyModal from "./parts/reviewscheduler/dedicated-agency-modal";
import SetupAppointment from "../LandingPage/parts/setup-appointment-modal";
import { Translate } from "react-translated";
import { API_DATE_FORMAT, debounceQuery, get_label_from_value } from "../../utils/Constants";
import {
  DESC,
  ASC,
  SORT_ORDER_ASCEND,
  SORT_ORDER_DESCEND
} from "../../utils/Constants";
import { BFILE_API_URL } from "../../utils/Api_enums";

const Option = Select.Option;
const { RangePicker } = DatePicker;
const today = new Date();
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class ReviewScheduler extends Component {
  state = {
    loading: false,
    period: "all_bfiles",
    start_date: null,
    end_date: null,
    filters_data: {
      search: "",
      agency: ""
    },
    buckets: [
      {
        index: 3,
        direction: DESC,
        title: "Due Date",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0
      
      },
      {
        index: 2,
        direction: DESC,
        title: "New Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0
        
      },
      {
        index: 0,
        direction: DESC,
        title: "Calls Made (Not Reached)",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        last_call_attempts_sort:DESC,
        call_attempts:DESC
        
      },
      {
        index: 1,
        direction: DESC,
        title: "Appointments Scheduled",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
      },
      {
        index: 4,
        direction: DESC,
        title: "Requested To Be Re-Scheduled",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
      }
    ],

    agency_id: null,
    user: this.props.auth.user,
    agencies: [],
    stats: {},
    stats_loading: false,
    dedicated_agency_modal: false,
    setup_appointment_modal: false,
    bfile: null
  };


  call_rs_agencies = ()=>{
    axios.get(`/api/rs_agencies${this.state.user.user_type==='SUPER_ADMIN' && this.props.history.location.state.user_type && `?user_type=${this.props.history.location.state.user_type}` ||''}`).then((res) => {
      this.setState({
        agencies: res.data
      });
    });
  }

  componentDidMount = () => {
    this.call_rs_agencies();

    // Default Select `All B Files`
    const data = F.getServerDateByType("all_bfiles");

    window.localStorage.user_start_date = data.from;
    window.localStorage.user_end_date = data.to;
    window.localStorage.user_period = "all_bfiles";

    const globalAgencyID =
      "rs_agency_id" in window.localStorage &&
      window.localStorage.rs_agency_id !== ""
        ? parseInt(window.localStorage.rs_agency_id)
        : null;

    if (globalAgencyID) {
      this.setState((prevState) => ({
        filters_data: {
          ...prevState.filters_data,
          agency: globalAgencyID || ''
        }
      }));
    }

    // Code for sorting
    let sorting_direction = {};

    if ("sorting_direction" in window.localStorage) {
      sorting_direction = JSON.parse(window.localStorage.sorting_direction);
    }

    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map(bucket => ({ ...bucket }));
      for (let i = 0; i < newBuckets.length; i++) {
        const api_index = newBuckets[i].index;
        if (sorting_direction.hasOwnProperty(api_index)) {
          newBuckets[i].direction = sorting_direction[api_index]; // DESC or ASC
        }
      }
      return { buckets: newBuckets, loading: true };
    }, () => {
      this.loadBuckets("all", 1);
      this.loadStats();
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      "action" in this.props.match.params &&
      this.props.match.params.action === "select-agency" &&
      prevState.dedicated_agency_modal === false
    ) {
      this.setState({ dedicated_agency_modal: true });
    }
  }
  changePeriod = (e) => {
    const value = e.target.value;

    const data = F.getServerDateByType(value);

    // start date
    let start_date = data.from;

    // end date
    let end_date = data.to;

    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = value;

    this.setState(
      {
        start_date: start_date,
        end_date: end_date,
        period: value
      },
      () => {
        this.loadBuckets("all", 1);
        this.loadStats();
      }
    );
  };
  search = () => {
    
    this.setState({ loading:true }, () => {
      this.loadBuckets("all", 1);
      this.loadStats();
    });
  };
  agencyChange = (agency_id) => {
    this.props.history.push("/dashboard");
    this.setState(
      (prevState) => ({
        loading: true,
        filters_data: {
          ...prevState.filters_data,
          agency: agency_id
        }
      }),
      () => {
      this.loadBuckets("all", 1);
      }
    );
  };
  onChangeDateRange = (date, dateString) => {
    let start_date = null;
    let end_date = null;
    let period = null;

    // Check If User pressed on `crossed` icon `Reset to Monthly View`
    if (dateString[0].length === 0 && dateString[1].length === 0) {
      start_date = moment(
        new Date(today.getFullYear(), today.getMonth(), 1)
      ).format("YYYY-MM-DD");

      // end date
      end_date = moment(
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");

      period = "mtd";
    } else {
      start_date = dateString[0];
      end_date = dateString[1];
      period = "from_to";
    }

    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = period;

    this.setState(
      {
        start_date,
        end_date,
        period
      },
      () => {
        this.loadBuckets("all", 1);
        this.loadStats();
      }
    );
  };
  refresh = () => {
    this.setState({ loading: true });
    axios.get("/api/delete_user_cache").then((res) => {
      this.setState({ 
        period: "all_bfiles",
        start_date: null,
        end_date: null,
        filters_data: {
          search: "",
          agency: ""
        },
        buckets: [
          {
            index: 3,
            direction: DESC,
            title: "Due Date",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
          
          },
          {
            index: 2,
            direction: DESC,
            title: "New Calls",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            
          },
          {
            index: 0,
            direction: DESC,
            title: "Calls Made (Not Reached)",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            
          },
          {
            index: 1,
            direction: DESC,
            title: "Appointments Scheduled",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
          },
          {
            index: 4,
            direction: DESC,
            title: "Requested To Be Re-Scheduled",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
          }
        ],
        });
      this.call_rs_agencies()
      this.loadBuckets("all", 1);
      this.loadStats();
    });
  };
  loadStats = () => {
    const { agency_id, user, period, start_date, end_date } = this.state;

    // const today = new Date();

    // let from = new Date(today.getFullYear(), today.getMonth(), 1);
    // let to = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    let from = null;
    let to = null;

    if (start_date != null && end_date != null) {
      from = start_date;
      to = end_date;
    }

    if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      from = datesData.from;
      to = datesData.to;
    }

    const globalAgencyID =
      "rs_agency_id" in window.localStorage &&
      window.localStorage.rs_agency_id !== ""
        ? parseInt(window.localStorage.rs_agency_id)
        : null;

    let url = "/api/user_review_stats";
    if (globalAgencyID) {
      url = "/api/user_review_stats?agency_id=" + globalAgencyID;
    }

    this.setState({ stats_loading: true });

    axios
      .post(url, {
        user: user.id,
        from: from,
        to: to
      })
      .then((res) => {
        this.setState({
          stats: res.data,
          stats_loading: false
        });
      });
  };

  sendNotification = (bfile) => {
    F.log("BFILE =>", bfile);
    // let { email, agency: { primary_ea_id } } = bfile

    // let data = {
    //     notification_message: `The phone number of the customer (${email}) is not valid, Kindly change it`,
    //     user_ids: [primary_ea_id],
    //     severity: "low",
    //     dispatch_time: Math.floor(Date.now() / 1000)
    // }

    axios
      .post("/api/get_all_user_for_bad_phone_number_notification", {
        agency_id: bfile.agency_id
      })
      .then((res) => {
        F.log("Res.data = > ", res.data.data);
        if (res.data.data.length) {
          let data = {
            notification_message: `The phone number for ###${bfile.first_name} ${bfile.last_name}### is not valid. Please update it.`,
            user_ids: res.data.data,
            severity: "low",
            dispatch_time: Math.floor(Date.now() / 1000),
            bfile_id: bfile.id
          };
          axios.post("/api/create_notification", data).then((res) => {
            F.log("res.data = > ", res.data);
            message.success(F.translate(`Notification Sent Successfully`));
          });
        } else {
          message.info(F.translate(`No Users to Notify`));
        }

        // this.setState({
        //     bad_phone : res.data.data
        // })
      });
  };

  loadBuckets = (sec, page) => {
    F.log("page", page);
    F.log("sec", sec);
    const { user } = this.state;
    const today = moment(
      moment(new Date())
        .utc()
        .format()
    ).format("YYYY-MM-DD");
    const tomorrow = moment(new Date())
      .add(1, "days")
      .format("YYYY-MM-DD");

    const due_date = moment(new Date())
      .add(-2, "days")
      .format("YYYY-MM-DD");

    if (sec === "all" || sec == 0) {
      this.loadBucket(
        0,
        BFILE_API_URL,
        '{"name":"rs_archived","op":"is_null"},{"name":"deleted","op":"==","val":"0"},{"name":"archive","op":"==","val":"0"},{"name":"reviewer_id","op":"==","val":"' +
          user.id +
          '"},{"name":"rs_action","op":"==","val":0},{"name":"deleted","op":"==","val":"0"}',
        page
      );
    }
    if (sec === "all" || sec == 3) {
      this.loadBucket(
        3,
        BFILE_API_URL,
        '{"name":"rs_archived","op":"is_null"},{"name":"deleted","op":"==","val":"0"},{"name":"archive","op":"==","val":"0"},{"name":"reviewer_id","op":"==","val":"' +
          user.id +
          '"},{"name":"rs_action","op":"==","val":0},{"name":"deleted","op":"==","val":"0"},{"name":"rs_notreached_date","op":"<=","val":"' +
          `${due_date} 23:59:59` +
          '"},{"name":"expiration_date","op":">=","val":"' +
          `${tomorrow} 00:00:00` +
          '"}',
        page
      );
    }
    if (sec === "all" || sec == 1) {
      this.loadBucket(
        1,
        BFILE_API_URL,
        '{"name":"rs_appointment_date","op":"is_not_null"},{"name":"rs_archived","op":"is_null"},{"name":"deleted","op":"==","val":"0"},{"name":"archive","op":"==","val":"0"},{"name":"reviewer_id","op":"==","val":"' +
          user.id +
          '"},{"name":"rs_action","op":"==","val":1},{"name":"deleted","op":"==","val":"0"},{"or":[{"name":"reschedule_appointment","op":"eq","val":"0"},{"name":"reschedule_appointment","op":"is_null"}]}',
        page
      );
    }
    if (sec === "all" || sec == 4) {
      this.loadBucket(
        4,
        BFILE_API_URL,
        '{"name":"rs_appointment_date","op":"is_not_null"},{"name":"rs_archived","op":"is_null"},{"name":"deleted","op":"==","val":"0"},{"name":"archive","op":"==","val":"0"},{"name":"reviewer_id","op":"==","val":"' +
          user.id +
          '"},{"name":"rs_action","op":"==","val":1},{"name":"deleted","op":"==","val":"0"},{"name":"reschedule_appointment","op":"==","val":"1"}',
        page
      );
    }
    // New Calls
    if (sec === "all" || sec == 2) {
      // New Task Condition -> Customer show on queue only when It's attempted max 5 times
      const not_reached_5_attempts = {
        or: [
          { name: "rs_attempts", op: "is_null" },
          { name: "rs_attempts", op: "<=", val: 5 }
        ]
      };
      // New Task Condition -> Customer show on queue only from the effective date
      const effective_date_condition = {
        or: [
          { name: "rs_effective_date", op: "is_null" },
          { name: "rs_effective_date", op: "<=", val: today }
        ]
      };
      this.loadBucket(
        2,
        BFILE_API_URL,

        JSON.stringify(not_reached_5_attempts) +
          ", " +
          JSON.stringify(effective_date_condition) +
          ' ,{"name":"expiration_date","op":">","val":"' +
          today +
          '"},{"name":"archive","op":"==","val":0},{"name":"rs_action","op":"is_null"},{"name":"is_saved_for_later","op":"==","val":"0"},{"name":"deleted","op":"==","val":"0"}',
        page
      );
    }
  };
  loadBucket = (ind, api, filters, page) => {
    F.log("ind", ind);
    const { user, period, start_date, end_date, agency_id ,filters_data} = this.state;

    let buckets = this.state.buckets;
    let more_filters = filters_data;
    let currentIndex =  this.state.buckets.findIndex(e=>e.index === ind)
    let direction = this.state.buckets[currentIndex] && this.state.buckets[currentIndex].direction || "asc";
    let order_by = this.state.buckets[currentIndex] && this.state.buckets[currentIndex].order_by || ([2,3,0].includes(ind)?'expiration_date': [4,1].includes(ind)? 'rs_appointment_date':'updated_on')

    let from = null;
    let to = null;

    if (start_date != null && end_date != null) {
      from = start_date;
      to = end_date;
    }

    if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      from = datesData.from;
      to = datesData.to;
    }

    if (filters !== "") filters = filters + ",";
    F.log("filters", filters);
    filters =
      filters +
      '{"or":[{"and":[{"name":"created_on","op":">=","val":"' +
      `${from} 00:00:00` +
      '"},{"name":"created_on","op":"<=","val":"' +
      `${to} 23:59:59` +
      '"}]},{"and":[{"name":"rs_date","op":">=","val":"' +
      `${from} 00:00:00` +
      '"},{"name":"rs_date","op":"<=","val":"' +
      `${to} 23:59:59` +
      '"}]}]}';

    // if (agency_id) {
    //   more_filters.agency = agency_id;
    // }
    let queries = null;
    if (
      typeof more_filters.search !== "undefined" &&
      more_filters.search !== ""
    ) {
      queries = F.getQuerySearchFilters(more_filters);

      filters = filters + ',{"or":' + JSON.stringify(queries) + "}";
    }

    filters = F.getDncFilter(filters);

    // if (agency_id) {
    //   filters =
    //     filters + ',{"name":"agency_id","op":"==","val":' + agency_id + "}";
    // } else

    if (more_filters.agency != null && more_filters.agency != "") {
      filters =
        filters +
        ',{"name":"agency_id","op":"==","val":' +
        more_filters.agency +
        "}";
    }
    // if (ind === 2) {
    //   if ("agency" in more_filters && more_filters.agency) {
    //     filters =
    //       filters +
    //       ',{"name":"agency_id","op":"==","val":' +
    //       more_filters.agency +
    //       "}";
    //   }
    // }

    // OLD
    // let url =
    //   "/api/" +
    //   api +
    //   "?page=" +
    //   page +
    //   '&q={"filters":[' +
    //   filters +
    //   '],"order_by":[{"field":"updated_on","direction":"desc"}]}';

    // if (ind === 1 || ind === 4) {
    //   url =
    //     "/api/" +
    //     api +
    //     "?page=" +
    //     page +
    //     '&q={"filters":[' +
    //     filters +
    //     '],"order_by":[{"field":"updated_on","direction":"desc"}]}';
    // }

    // NEW
    let url =
      "/" + api + '?page=' + page + '&q={"filters":[' + filters + "]";

    let orderBy =
      ',"order_by":[{"field":"' + order_by + '","direction":' +
      `"${direction}"` +
      "}]}";


    url = `${url}${orderBy}`;

    axios.get(url).then((res) => {
      buckets = this.state.buckets;
      let data = [];
      for (let i = 0; i < res.data.objects.length; i++) {
        let bfile = res.data.objects[i];
        let action = null;

        if (ind !== 1) {
          action = (
            <div className="right-align">
              <Button.Group>
                <Button
                  style={{ marginLeft: 10 }}
                  onClick={() =>
                    this.setState({
                      setup_appointment_modal: true,
                      bfile
                    })
                  }
                >
                  <Translate text={`Setup Appointment`} />
                </Button>

                {/* <Button onClick={() => this.complete(ind, bfile.id)}>
                  Complete/Archive
                </Button> */}
                {this.renderCompleteButton(ind, bfile)}
                <Button type="primary" onClick={() => this.view(bfile.id)}>
                  View
                </Button>
                <Popconfirm
                  placement="topRight"
                  title={"Do you really want to delete this B File?"}
                  onConfirm={() => this.delete(ind, bfile.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button>Delete</Button>
                </Popconfirm>
                <Button
                  style={{ marginLeft: 10 }}
                  onClick={() => this.sendNotification(bfile)}
                >
                  <Translate text={`Request New Number`} />
                </Button>
              </Button.Group>
            </div>
          );
        } else {
          action = (
            <div className="right-align">
              <Button.Group>
                <Button type="primary" onClick={() => this.view(bfile.id)}>
                  View
                </Button>
                <Popconfirm
                  placement="topRight"
                  title={"Do you really want to delete this B File?"}
                  onConfirm={() => this.delete(ind, bfile.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button>Delete</Button>
                </Popconfirm>
              </Button.Group>
            </div>
          );
        }

        data.push({
          key: i,
          name: (
            <div className="autoHandleContentStyle" style={{ width: 150 }}>
              <Link to={"/customer/" + bfile.id}>
                {bfile.first_name + " " + bfile.last_name}
              </Link>
            </div>
          ),
          phone: (
            <a href={"tel:" + F.phone_format(bfile.phone)}>
              {F.phone_format(bfile.phone)}
            </a>
          ),
          // phone2: (
          //   <div className="autoHandleContentStyle" style={{ width: 150 }}>
          //     <a href={"tel:" + F.phone_format(bfile.phone2)}>
          //       {F.phone_format(bfile.phone2)}
          //     </a>
          //   </div>
          // ),
          agency: bfile.agency.name,
          type_of_call: bfile.type_of_call,
          sub_type_of_call: (<div style={{ width: 150 }}>
          <Tooltip title={get_label_from_value(bfile.sub_type_of_call,'label',bfile.type_of_call)}>
            <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {get_label_from_value(bfile.sub_type_of_call,'label',bfile.type_of_call)}
            </div>
          </Tooltip>
        </div>),
          expiration_date: bfile.expiration_date
            ? moment(bfile.expiration_date).format("MM/DD/YYYY")
            : "-",
          // status: F.bfile_status(bfile), // commenting this because there was no column for status
          // due_date: F.bfile_due_date(bfile, user.default_date),
          due_date: bfile.expiration_date
            ? moment(bfile.expiration_date).format("MM/DD/YYYY")
            : "-",
          call_attempts: bfile.rs_attempts,
          last_call_attempts:bfile.rs_notreached_date ? moment(bfile.rs_notreached_date).format("MM/DD/YYYY"):"-",
          who_created: bfile.user.first_name + " " + bfile.user.last_name,
          appointment_date: bfile.rs_appointment_date
            ? moment(bfile.rs_appointment_date)
                // .utc()
                .format("MM/DD/YYYY")
            : "-",
          action: action,
          rs_effective_date:bfile.rs_effective_date && moment(bfile.rs_effective_date, 'YYYY-MM-DD').format('MM/DD/YYYY') || ""
        });
      }
      for (let i = 0; i < buckets.length; i++) {
        if (buckets[i].index === ind) {
          buckets[i].loading = false;
          buckets[i].page = res.data.page;
          buckets[i].calls = data;
          buckets[i].total_pages = res.data.total_pages;
          break;
        }
      }

      this.setState({ buckets },()=>{
        setTimeout(()=>{
            this.setState({loading:false})
        },2000)
       
      });

    });
  };


  
  complete = (ind, bfile_id) => {
    this.setState(
      (prevState) => ({
        buckets: prevState.buckets.map((bucket) =>
          bucket.index === ind ? { ...bucket, loading: true } : bucket
        )
      }),
      () => {
        axios
          .put("/api/b_file/" + bfile_id, {
            rs_archived: 1
          })
          .then(() => {
            this.loadBuckets(ind, 1);
          });
      }
    );
  };
  delete = (ind, bfile_id) => {
    this.setState(
      (prevState) => ({
        buckets: prevState.buckets.map((bucket) =>
          bucket.index === ind ? { ...bucket, loading: true } : bucket
        )
      }),
      () => {
        axios
          .put("/api/b_file/" + bfile_id, {
            deleted: 1
          })
          .then(() => {
            this.loadBuckets(ind, 1);
          });
      }
    );
  };
  view = (bfile_id) => {
    this.props.history.push("/customer/" + bfile_id);
  };
  onSelectAgency = (agency_id) => {
    this.setState(
      (prevState) => ({
        filters_data: {
          ...prevState.filters_data,
          agency: agency_id
        }
      }),
      () => {
        this.loadStats();
        this.loadBuckets("all", 1);
      }
    );
  };

  /**
   * Method will render `Complete` Button
   * @returns
   */
  renderCompleteButton = (ind, bfile) => {
    // const isAppScheduledAndBFileNotComplete = F.isAppointmentScheduledAndBFileNotCompleted(
    //   bfile
    // );

    const isNotCompleted = bfile.rs_archived != 1;

    return isNotCompleted ? (
      <Button onClick={() => this.complete(ind, bfile.id)}>
        Complete/Archive
      </Button>
    ) : null;
  };

  saveSortingDirectionInLocalStorage = (ind, direction) => {
    // get existing `sorting direction` object from local storage
    const sorting_direction =
      "sorting_direction" in window.localStorage
        ? JSON.parse(window.localStorage.sorting_direction)
        : {};

    // update direction by `index`
    sorting_direction[ind] = direction;

    // update in local storage
    window.localStorage.sorting_direction = JSON.stringify(sorting_direction);
  };

  onSortingChange = (vertical_index, api_index, key, order_by) => {
    this.setState(
      (prevState) => {
        const newBuckets = prevState.buckets.map((bucket, index) =>
          index === vertical_index
            ? { ...bucket, [key]: bucket[key] === DESC ? ASC : DESC, loading: true, order_by }
            : bucket
        );

        // Save sorting direction in local storage
        this.saveSortingDirectionInLocalStorage(api_index, newBuckets[vertical_index][key]);

        return { buckets: newBuckets };
      },
      () => {
        this.loadBuckets(api_index, 1);
      }
    );
  };

  onSearchAgency = (value) => {
    this.setState(
      (prevState) => ({
        filters_data: {
          ...prevState.filters_data,
          search: value
        }
      }),
      () => {
        debounceQuery(() => this.search());
      }
    );
  };

  render() {
    const {
      start_date,
      end_date,
      period,
      user,
      loading,
      filters_data,

      agencies,
      stats,
      stats_loading,
      dedicated_agency_modal,
      agency_id
    } = this.state;
    F.log("this.state", this.state);
    const dateFormat = "YYYY-MM-DD";

    let defaultFromDate = new Date("2010-01-01");
    if (start_date) defaultFromDate = new Date(start_date);

    let defaultToDate = new Date("2050-01-01");
    if (end_date) defaultToDate = new Date(end_date);

    /****************** Hide code for displaying `Due Date` section always *******************/

    //  const globalAgencyID =
    //    "rs_agency_id" in window.localStorage &&
    //    window.localStorage.rs_agency_id !== ""
    //      ? parseInt(window.localStorage.rs_agency_id)
    //      : null;

    //  let buckets = this.state.buckets;
    //  if (globalAgencyID) {
    //    buckets = [
    //      buckets[1],
    //      buckets[4],
    //      buckets[0],
    //      buckets[2],
    //      buckets[3],
    //    ];
    //  } else {
    //    buckets = [buckets[1], buckets[4], buckets[2], buckets[3]];
    //  }
    /****************** Add New Code For displaying `Due Date` section always *******************/
    let buckets = this.state.buckets;
    buckets = [buckets[1], buckets[4], buckets[0], buckets[2], buckets[3]];

//     let dueDateColumnsData = [
//       {
//         title: "Name",
//         dataIndex: "name",
//         key: "name"
//       },
//       {
//         title: "Phone",
//         dataIndex: "phone",
//         key: "phone"
//       },
//       /*
// {
//         title: "Alternate Phone Number",
//         dataIndex: "phone2",
//         key: "phone2"
//       },
// */
//       {
//         title: "Agency",
//         dataIndex: "agency",
//         key: "agency"
//       },
//       {
//         title: <Translate text={`type_of_call`} />,
//         dataIndex: "type_of_call",
//         key: "type_of_call"
//       },
//       {
//         title: <Translate text={`sub_type_of_call`} />,
//         dataIndex: "sub_type_of_call",
//         key: "sub_type_of_call"
//       },
//       {
//         title: "Due Date",
//         dataIndex: "due_date",
//         key: "due_date",

//         sortOrder:
//           this.state.buckets[0].direction === DESC
//             ? SORT_ORDER_DESCEND
//             : SORT_ORDER_ASCEND,
//         onHeaderCell: () => {
//           return {
//             onClick: () => {
//               this.onSortingChange(0, 3);
//             }
//           };
//         },
//         sorter: true
//       },
//       {
//         title: "Call Attempts",
//         dataIndex: "call_attempts",
//         key: "call_attempts"
//       },
//       {
//         title: "Who Created",
//         dataIndex: "who_created",
//         key: "who_created"
//       },
//       {
//         title: "Action",
//         dataIndex: "action",
//         key: "action"
//       }
//     ];
    let callsMadeNotReachedColumnsData = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sortOrder:
        this.state.buckets[2].direction === DESC
          ? SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(2, 0,'direction','first_name');
          }
        };
      },
      sorter: true
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone"
      },
      /*
{
        title: "Alternate Phone Number",
        dataIndex: "phone2",
        key: "phone2"
      },
*/
      {
        title: "Agency",
        dataIndex: "agency",
        key: "agency"
      },
      {
        title: <Translate text={`type_of_call`} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
        width:120,
        sortOrder:
        this.state.buckets[2].direction === DESC
          ? SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(2, 0,'direction','type_of_call');
          }
        };
      },
      sorter: true
      },
      {
        title: <Translate text={`sub_type_of_call`} />,
        dataIndex: "sub_type_of_call",
        key: "sub_type_of_call",
        sortOrder:
        this.state.buckets[2].direction === DESC
          ? SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(2, 0,'direction',"sub_type_of_call");
          }
        };
      },
      sorter: true
      },
      {
        title: "Active Call Date",
        dataIndex: "rs_effective_date",
        key: "rs_effective_date",
        width:140,
        sortOrder:
          this.state.buckets[0].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(2, 0,"direction","rs_effective_date");
            }
          };
        },
        sorter: true
      },
      {
        title: "Schedule By Date",
        dataIndex: "due_date",
        key: "due_date",
        width:150,
        sortOrder:
          this.state.buckets[0].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(2, 0,"direction","expiration_date");
            }
          };
        },
        sorter: true
      },
      // {
      //   title: "Due Date",
      //   dataIndex: "due_date",
      //   key: "due_date",

      //   sortOrder:
      //     this.state.buckets[0].direction === DESC
      //       ? SORT_ORDER_DESCEND
      //       : SORT_ORDER_ASCEND,
      //   onHeaderCell: () => {
      //     return {
      //       onClick: () => {
      //         this.onSortingChange(2, 0,"direction","expiration_date");
      //       }
      //     };
      //   },
      //   sorter: true
      // },
      {
        title: "Call Attempts",
        dataIndex: "call_attempts",
        key: "call_attempts",
        width:130,
        sortOrder:
          this.state.buckets[2].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(2, 0,'direction','rs_attempts');
            }
          };
        },
        sorter: true

      },
      {
        title: "Last Call Attempts",
        dataIndex: "last_call_attempts",
        key: "last_call_attempts",
        width:130,
        sortOrder:
          this.state.buckets[2].last_call_attempts_sort === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(2, 0,'direction','rs_notreached_date');
            }
          };
        },
        sorter: true

      },
      {
        title: "Who Created",
        dataIndex: "who_created",
        key: "who_created"
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action"
      }
    ];
    let appointmentScheduledData = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sortOrder:
          this.state.buckets[3].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(3, 1,'direction','first_name');
            }
          };
        },
        sorter: true
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone"
      },
      /*
{
        title: "Alternate Phone Number",
        dataIndex: "phone2",
        key: "phone2"
      },
*/
      {
        title: "Agency",
        dataIndex: "agency",
        key: "agency"
      },
      {
        title: <Translate text={`type_of_call`} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
        width:120,
        sortOrder:
          this.state.buckets[3].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(3, 1,'direction','type_of_call');
            }
          };
        },
        sorter: true
      },
      {
        title: <Translate text={`sub_type_of_call`} />,
        dataIndex: "sub_type_of_call",
        key: "sub_type_of_call",
        sortOrder:
        this.state.buckets[3].direction === DESC
          ? SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(3, 1,'direction','sub_type_of_call');
          }
        };
      },
      sorter: true
      },
      {
        title: "Appointment Date",
        dataIndex: "appointment_date",
        key: "appointment_date",

        sortOrder:
          this.state.buckets[3].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(3, 1,'direction','rs_appointment_date');
            }
          };
        },
        sorter: true
      },
      {
        title: "Call Attempts",
        dataIndex: "call_attempts",
        key: "call_attempts",
        width:130,
        sortOrder:
        this.state.buckets[3].direction === DESC
          ? SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(3, 1,'direction','rs_attempts');
          }
        };
      },
      sorter: true
      },
      {
        title: "Who Created",
        dataIndex: "who_created",
        key: "who_created"
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action"
      }
    ];
    let requestedToBeRescheduledData = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sortOrder:
          this.state.buckets[4].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(4, 4,'direction','first_name');
            }
          };
        },
        sorter: true
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone"
      },
      /*
{
        title: "Alternate Phone Number",
        dataIndex: "phone2",
        key: "phone2"
      },
*/
      {
        title: "Agency",
        dataIndex: "agency",
        key: "agency"
      },
      {
        title: <Translate text={`type_of_call`} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
        width:120,
        sortOrder:
          this.state.buckets[4].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(4, 4,'direction','type_of_call');
            }
          };
        },
        sorter: true
      },
      {
        title: <Translate text={`sub_type_of_call`} />,
        dataIndex: "sub_type_of_call",
        key: "sub_type_of_call",
        sortOrder:
          this.state.buckets[4].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(4, 4,'direction','sub_type_of_call');
            }
          };
        },
        sorter: true
      },
      {
        title: "Appointment Date",
        dataIndex: "appointment_date",
        key: "appointment_date",

        sortOrder:
          this.state.buckets[4].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(4, 4,'direction','rs_appointment_date');
            }
          };
        },
        sorter: true
      },
      {
        title: "Call Attempts",
        dataIndex: "call_attempts",
        key: "call_attempts",
        width:130,
        sortOrder:
          this.state.buckets[4].direction === DESC
            ? SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(4, 4,'direction','rs_attempts');
            }
          };
        },
        sorter: true
      },
      {
        title: "Who Created",
        dataIndex: "who_created",
        key: "who_created"
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action"
      }
    ];
    let newCalls = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sortOrder:
          this.state.buckets[1].direction === DESC
            ?  SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(1, 2,'direction','first_name');
            }
          };
        },
        sorter: true
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone"
      },
      /*
{
        title: "Alternate Phone Number",
        dataIndex: "phone2",
        key: "phone2"
      },
*/
      {
        title: "Agency",
        dataIndex: "agency",
        key: "agency"
      },
      {
        title: <Translate text={`type_of_call`} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
        width:120,
        sortOrder:
        this.state.buckets[1].direction === DESC
          ?  SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(1, 2,'direction','type_of_call');
          }
        };
      },
      sorter: true
      },
      {
        title: <Translate text={`sub_type_of_call`} />,
        dataIndex: "sub_type_of_call",
        key: "sub_type_of_call",
        sortOrder:
        this.state.buckets[1].direction === DESC
          ?  SORT_ORDER_DESCEND
          : SORT_ORDER_ASCEND,
      onHeaderCell: () => {
        return {
          onClick: () => {
            this.onSortingChange(1, 2,'direction','sub_type_of_call');
          }
        };
      },
      sorter: true
      },
      {
        title: "Active Call Date",
        dataIndex: "rs_effective_date",
        key: "rs_effective_date",
        width:140,
        sortOrder:
          this.state.buckets[1].direction === DESC
            ?  SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        // sorter: (a, b) =>  moment(new Date(a.expiration_date)).format(API_DATE_FORMAT) - moment(new Date(b.expiration_date)).format(API_DATE_FORMAT),    
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(1, 2,'direction','rs_effective_date');
            }
          };
        },
        sorter: true
      },
      {
        title: "Schedule by Date",
        dataIndex: "expiration_date",
        key: "expiration_date",
        width:150,
        sortOrder:
          this.state.buckets[1].direction === DESC
            ?  SORT_ORDER_DESCEND
            : SORT_ORDER_ASCEND,
        // sorter: (a, b) =>  moment(new Date(a.expiration_date)).format(API_DATE_FORMAT) - moment(new Date(b.expiration_date)).format(API_DATE_FORMAT),    
        onHeaderCell: () => {
          return {
            onClick: () => {
              this.onSortingChange(1, 2,'direction','expiration_date');
            }
          };
        },
        sorter: true
      },
      {
        title: "Who Created",
        dataIndex: "who_created",
        key: "who_created"
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action"
      }
    ];

    return (
      <div>
        <div className="topbar">
          <Card bordered={false}>
            <Row gutter={16} type="flex" justify="space-around" align="middle">
              <Col md={8} span={24}>
                <div className="username">
                  <Icon type="user" />
                  {user.first_name + " " + user.last_name}{" "}
                  <Tag color="blue">{user.user_type}</Tag>
                </div>
              </Col>
              <Col md={16} span={24}>
                <div
                  className="right-align"
                  style={{ marginTop: -5, marginBottom: -5 }}
                >
                  <div className="inlineField">
                    <Button icon="reload" onClick={this.refresh.bind(this)}>
                      {" "}
                      <Translate text={`Refresh`} />
                    </Button>
                  </div>
                  <div className="inlineField">
                    <Radio.Group
                      value={period}
                      onChange={this.changePeriod.bind(this)}
                      style={{ width: "100%" }}
                    >
                      <Radio.Button value="mtd">
                        <Translate text={`This Month`} />
                      </Radio.Button>
                      <Radio.Button value="all_bfiles">
                        <Translate text={`All B Files`} />
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div className="inlineField">
                    <RangePicker
                      value={[moment(defaultFromDate), moment(defaultToDate)]}
                      onChange={this.onChangeDateRange}
                      format={dateFormat}
                      style={{ maxWidth: 200 }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </div>
        <Row
                      gutter={16}
                      style={{ marginBottom:10 }}
                    
                      type="flex"
                      justify="end"
                    >
                      <Col md={5} span={12}>
                        <Input
                          prefix={<Icon type="search" />}
                          onChange={(e) => this.onSearchAgency(e.target.value)}
                          value={filters_data.search}
                          placeholder="Search..."
                          // onPressEnter={(e) => {
                          //   const searchPurify = F.removeSpecialCharactersFromString(
                          //     e.target.value
                          //   );

                          //   // if (searchPurify.trim().length > 0) {
                          //   //   this.search(bucket.index, searchPurify);
                          //   // }
                          //   this.search(bucket.index, searchPurify);
                          // }}
                        />
                      </Col>
                      <Col md={5} span={12} style={{overflow:'hidden'}}>
                        <Select
                          value={filters_data.agency}
                          style={{ width: "100%",background:"white",}}
                          onChange={(val) => {
                            this.agencyChange(val);
                          }}
                        >
                          <Option value={""}>{"Filter by Agency"}</Option>
                          {agencies.map((agency, i) => (
                            <Option key={i} value={+agency.id}>
                              {agency.name}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                    </Row>
        <Spin indicator={antIcon} spinning={loading}>
          {buckets.map((bucket, i) => {
            if(bucket.title === 'Due Date')
            return null
            // F.log("index --> " + i + " --> " + bucket.filters.agency);
            return (
              <Card
                key={i}
                type="inner"
                className="tableCard"
                title={
                  <div style={{ paddingTop: 7 }}>
                    <Icon
                      type="folder"
                      style={{ marginRight: 10, color: "#1890ff" }}
                    />
                    {bucket.title}
                  </div>
                }
                loading={bucket.loading||loading}
                style={{ marginBottom: 20 }}
                
              >
                {/* {bucket.index === 3 ? (
                  <Table
                    columns={dueDateColumnsData}
                    dataSource={bucket.calls}
                    bordered={false}
                    pagination={false}
                  />
                ) : null} */}
                {bucket.index === 2 ? (
                  <Table
                    columns={newCalls}
                    dataSource={bucket.calls}
                    bordered={false}
                    pagination={false}
                    locale={{ emptyText: "No Data To Show" }}
                  />
                ) : null}
                {bucket.index === 0 ? (
                  <Table
                    columns={callsMadeNotReachedColumnsData}
                    dataSource={bucket.calls}
                    bordered={false}
                    pagination={false}
                    locale={{ emptyText: "No Data To Show" }}
                  />
                ) : null}
                {bucket.index === 1 ? (
                  <Table
                    columns={appointmentScheduledData}
                    dataSource={bucket.calls}
                    bordered={false}
                    pagination={false}
                    locale={{ emptyText: "No Data To Show" }}
                  />
                ) : null}

                {bucket.index === 4 ? (
                  <Table
                    columns={requestedToBeRescheduledData}
                    dataSource={bucket.calls}
                    bordered={false}
                    pagination={false}
                    locale={{ emptyText: "No Data To Show" }}
                  />
                ) : null}

                {!bucket.loading ? (
                  <Pagination
                    current_page={bucket.page}
                    total_pages={bucket.total_pages}
                    onClick={(page) => {
                      this.loadBuckets(bucket.index, page);
                    }}
                  />
                ) : null}
              </Card>
            );
          })}
        </Spin>

        <Stats
          stats={stats}
          loading={stats_loading}
          user={user}
          start_date={start_date}
          end_date={end_date}
          period={period}
          history={this.props.history}
        />

        <AgencyModal
          history={this.props.history}
          showModal={dedicated_agency_modal}
          hideModal={() => {
            // this.props.history.push("/dashboard");
            this.setState({ dedicated_agency_modal: false });
            this.props.history.replace("/dashboard");
          }}
          onSelectAgency={this.onSelectAgency}
        />

        {this.state.setup_appointment_modal && this.state.bfile ? (
          <SetupAppointment
            history={this.props.history}
            showModal={this.state.setup_appointment_modal}
            hideModal={() => this.setState({ setup_appointment_modal: false })}
            bfile={this.state.bfile}
            user={user}
            refresh={this.refresh}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}

export default ReviewScheduler;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/reviewscheduler.js